/**
 * OperationsDashboard — Phase 10A.6 rename.
 *
 * The Phase 10A computed dashboard (session counts, action items, teacher workload)
 * is now a standalone page under /operations-dashboard, separate from the
 * form-fill Reports (/reports) area.
 *
 * data-testid: candeza-reports-operations-page (root)
 */

import React from 'react';
import { PageContainer } from '@/components/layout';
import { OfficeManagerReport } from './office-manager/OfficeManagerReport';

export const OperationsDashboard: React.FC = () => {
  return (
    <PageContainer
      title="Operations Dashboard"
      subtitle="Real-time operational health — sessions, action items, teacher workload"
      data-testid="candeza-reports-operations-page"
      data-flow="operations-dashboard-page"
    >
      <OfficeManagerReport />
    </PageContainer>
  );
};

